export default __webpack_public_path__ + "static/media/icon-trackntrace.7b963158.svg";